import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Cookies from 'js-cookie'
import "./Subscribe.css";

const OtpVerify = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [canResend, setCanResend] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const msisdn = location.state?.msisdn;
  const bundle_id = "939";

  const handleChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;
    const updated = [...otp];
    updated[index] = value;
    setOtp(updated);
    if (value && index < 3) inputRefs.current[index + 1].focus();
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleVerifyOTP = async () => {
    const fullOtp = otp.join("");
    if (fullOtp.length !== 4) {
      toast.error("Enter all 4 digits of the OTP.");
      return;
    }

    const data = {
      number: msisdn,
      bundle_id,
      otp: fullOtp,
    };

    try {
  setLoading(true);
  const res = await axios.post("/register-otp", data);
  setLoading(false);

  if (res.data.code === 0 || res.data.code === 302) {
  Cookies.set("msisdn", msisdn, { expires: 1 });
  toast.success("OTP Verified!");
  setTimeout(() => navigate("/"), 4000); 

  } else {
    toast.error(res.data.message || "Invalid OTP.");
  }
} catch (err) {
  setLoading(false);
navigate('/')

  toast.error("Something went wrong. Please try again.");
}

//     try {
//       setLoading(true);
//       const res = await axios.post("/register-otp", data);
//       setLoading(false);
//  Cookies.set('msisdn',msisdn,{expires:1})
//       if (res.data.code === 0 || res.data.code === 302) {
       
//         toast.success("OTP Verified!");

//         setTimeout(() => navigate("/"), 5000);
//       } else {
//         toast.error(res.data.message || "Invalid OTP.");
//       }
//     } catch (err) {
//       setLoading(false);
//       toast.error("Verification failed.");
//       console.error(err);
//     }
  };

  const handleResendOtp = async () => {
    if (!canResend) return;

    setResendLoading(true);
    setCanResend(false);
    setCountdown(30);

    try {
      const res = await axios.post("/send-otp", {
        number: msisdn,
        bundle_id,
      });

      if (res.data.code === 0) {
        toast.success("OTP resent successfully!");
      } else {
        toast.error(res.data.message || "Failed to resend OTP.");
      }
    } catch (err) {
      toast.error("Error resending OTP.");
    } finally {
      setResendLoading(false);
    }
  };

  useEffect(() => {
    if (!canResend && countdown > 0) {
      const timer = setTimeout(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setCanResend(true);
    }
  }, [countdown, canResend]);

  return (
    <div className="subscribe-container">
      <img src="/assets/images/newLogo.png" alt="Zeropoint Logo" className="subscribe-logo" />
      <div className="subscribe-card">
        <h1 className="subscribe-title">Enter Your OTP</h1>
        <p className="subscribe-desc">A 4-digit code has been sent to {msisdn}</p>

        <div className="otp-input-container">
          {otp.map((digit, idx) => (
            <input
              key={idx}
              type="text"
              maxLength={1}
              value={digit}
              inputMode="numeric"
              ref={(el) => (inputRefs.current[idx] = el)}
              onChange={(e) => handleChange(e.target.value, idx)}
              onKeyDown={(e) => handleKeyDown(e, idx)}
              className="otp-box"
            />
          ))}
        </div>

        <button onClick={handleVerifyOTP} className="subscribe-button" disabled={loading}>
          {loading ? "Verifying..." : "Verify OTP"}
        </button>

        <p className="subscribe-desc">Please enter the received CODE to enjoy the service !!</p>

        <p className="text-xs text-center mt-3">
          Didn't receive OTP?{" "}
          {canResend ? (
            <span
              onClick={handleResendOtp}
              className="text-orange-600 font-bold cursor-pointer"
            >
              {resendLoading ? "Resending..." : "Resend OTP"}
            </span>
          ) : (
            <span className="text-gray-500">Resend in {countdown}s</span>
          )}
        </p>
      </div>

      {/* <ToastContainer position="top-center" autoClose={3000} /> */}
    </div>
  );
};

export default OtpVerify;
